// Notification sound: gentle two-tone chime via WebAudio (no asset file), with a mute preference.
import { toast } from "sonner";

const KEY = "app_sound_muted";
let ctx;
let lastPlay = 0;
let installed = false;

export const isSoundMuted = () => localStorage.getItem(KEY) === "1";

export const setSoundMuted = (muted) => {
  localStorage.setItem(KEY, muted ? "1" : "0");
  window.dispatchEvent(new Event("app-sound"));
};

const tone = (freq, start, dur, vol) => {
  const o = ctx.createOscillator();
  const g = ctx.createGain();
  o.type = "sine";
  o.frequency.value = freq;
  const t0 = ctx.currentTime + start;
  g.gain.setValueAtTime(0.0001, t0);
  g.gain.linearRampToValueAtTime(vol, t0 + 0.012);
  g.gain.exponentialRampToValueAtTime(0.0001, t0 + dur);
  o.connect(g).connect(ctx.destination);
  o.start(t0);
  o.stop(t0 + dur + 0.05);
};

export const playNotifySound = () => {
  if (isSoundMuted()) return;
  if (typeof window !== "undefined" && window.__introActive) return; // no chime over the intro video
  const now = Date.now();
  if (now - lastPlay < 400) return; // throttle toast bursts
  lastPlay = now;
  try {
    ctx = ctx || new (window.AudioContext || window.webkitAudioContext)();
    if (ctx.state === "suspended") ctx.resume();
    tone(880, 0, 0.18, 0.055);
    tone(1318.5, 0.09, 0.24, 0.045);
  } catch {
    // audio unavailable / blocked until first user gesture — ignore
  }
};

// Patch sonner's toast methods once so EVERY notification app-wide plays the chime.
export const installToastSounds = () => {
  if (installed) return;
  installed = true;
  ["success", "error", "info", "warning", "message"].forEach((k) => {
    const orig = toast[k];
    if (typeof orig !== "function") return;
    toast[k] = (...args) => {
      playNotifySound();
      return orig(...args);
    };
  });
};
